/* tslint:disable */
/* eslint-disable */
/**
 * Retool API
 * The Retool API is in beta. Go to Settings > API to get started. Once you generate an API token, use bearer token authentication to make requests.
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomComponentLibrariesPostRequest
 */
export interface CustomComponentLibrariesPostRequest {
    /**
     * Specifies a specific id to use for the library. Used for syncronizing libraries across Retool Instances.
     * @type {string}
     * @memberof CustomComponentLibrariesPostRequest
     */
    id?: string;
    /**
     * How the library will be referred to in Toolscript, and other code based usages.
     * @type {string}
     * @memberof CustomComponentLibrariesPostRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CustomComponentLibrariesPostRequest
     */
    description: string | null;
    /**
     * How the library will be referred to in the Retool UI. Should be human readable.
     * @type {string}
     * @memberof CustomComponentLibrariesPostRequest
     */
    label: string;
}

/**
 * Check if a given object implements the CustomComponentLibrariesPostRequest interface.
 */
export function instanceOfCustomComponentLibrariesPostRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function CustomComponentLibrariesPostRequestFromJSON(json: any): CustomComponentLibrariesPostRequest {
    return CustomComponentLibrariesPostRequestFromJSONTyped(json, false);
}

export function CustomComponentLibrariesPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomComponentLibrariesPostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'description': json['description'],
        'label': json['label'],
    };
}

export function CustomComponentLibrariesPostRequestToJSON(value?: CustomComponentLibrariesPostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'label': value.label,
    };
}

